<template>
    <v-navigation-drawer class="pro-menu d-none d-sm-block"
                         dark
                         fixed
                         floating
                         :mini-variant.sync="mini"
                         mini-variant-width="90px"
                         permanent>

        <div class="top-menu" v-if="!notFoundContact">
            <div class="position-absolute mini-icon" v-if="!mini">
                <v-btn icon @click.stop="mini = !mini">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </div>
            <div class="d-flex ml-5 mr-5 main-top-menu" v-if="!mini">
                <div class="mt-auto mb-auto">
                    <v-img height="50px"
                           width="50px"
                           class="mr-3"
                           src="/images/default-user.svg">
                    </v-img>
                </div>

                <div class="mt-auto mb-auto">
                    <div v-if="contact === null">
                        <content-placeholders :rounded="true">
                            <content-placeholders-heading style="width: 150px" />
                        </content-placeholders>
                    </div>
                    <div v-else>
                        <div class="email-address">{{ contact.email }}</div>
                        <div class="email-address">{{ contact.first_name }} {{ contact.last_name }}</div>
                    </div>
                </div>
            </div>
            <div class="main-top-menu text-center" style="padding-top: 37px" v-else>
                <v-icon class="mt-auto mb-auto" large @click.stop="mini = !mini">menu</v-icon>
            </div>

            <div class="text-center update-profil-txt" v-if="!mini">
                <a @click="redirect('/espace-pro/'+ token + '/profil')">
                    Mettre à jour mon profil
                </a>
            </div>

        </div>

        <v-divider></v-divider>

        <v-list v-if="!notFoundContact">
            <v-list-item link @click="redirect('/espace-pro/' + token + '/solicitations')">
                <v-list-item-icon>
                    <v-icon>assignment</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Mes sollicitations</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link @click="redirect('/espace-pro/' + token + '/review')">
                <v-list-item-icon>
                    <v-icon>rate_review</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Votre avis</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link @click="redirect('/espace-pro/' + token + '/uska')"
            v-if="uskaFreemium && providersCount > 0 && hasProviders">
                <v-list-item-icon>
                    <img src="/images/logo_USKA_empty.png" class="uska-icon"/>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Mon compte Uska</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <confirm ref="confirm"></confirm>
    </v-navigation-drawer>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Confirm from "../tools/Confirm"

export default {
    name: "ProMenu",
    components: {Confirm},
    props:['hasProviders', 'hasUska', 'providersCount', 'uskaFreemium'],
    data() {
        return {
            token: null,
            mini: false,
            env: process.env.NODE_ENV
        }
    },
    methods: {
        ...mapMutations('global', [
            'setLeftMenuClosed'
        ]),
        matchPath(path) {
            return this.$route.params.pathMatch.includes(path)
        },
        redirect(link) {
            if(this.matchPath('formulaire') && this.isDirty) {
                this.$refs.confirm.open('Attention',
                    'Vous allez quitter la page sans avoir validé ou enregistré votre formulaire.<br>',
                    { color: 'red', confirmColor: 'red', cancelColor: '#0b697e' }).
                then((confirm) => {
                    if(confirm) {
                        this.$router.push(link)
                    }
                })
            } else {
                this.$router.push(link)
            }
        }
    },
    computed: {
        ...mapState('pro', ['contact', 'notFoundContact']),
        ...mapState('web_form', ['isDirty'])
    },
    watch: {
        mini() {
            this.setLeftMenuClosed(this.mini)
        }
    },
    created() {
        this.token = this.$route.params.token

        this.$store.dispatch('pro/fetchContact', this.token)

        this.setLeftMenuClosed(this.mini)
    },
    mounted() {
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width

        this.mini = width <= 768
    }
}
</script>